const initialState = {
    loaded: false,
    events: [],
    contacts: [],
    client: {},
    eventsPaginationData: {},
    fetchOnMount: true
};

export default function activeClient(state = initialState, action = {}) {
    switch (action.type) {
        case 'UNMOUNT_CLIENT_PAGE':
            return initialState;
        case 'CLIENT_REFRESHED':
            var { client } = action;

            return {
                ...state,
                client: client
            };
        case 'TIMELINE_EVENT_ADDED':
            var { event } = action;
            event.newlyAdded = true;

            return {
                ...state,
                events: state.events.concat([event])
            };
        case 'CLEAR_OUT_ACTIVE_CLIENT_CONTACTS':
            return {
                ...state,
                contacts: []
            };
        case 'ACTIVE_CLIENT_LOAD':
            return {
                ...state,
                events: [],
                contacts: [],
                eventsPaginationData: {},
                loaded: false,
            };
        case 'ACTIVE_CLIENT_LOAD_SUCCESS':
            return {
                ...state,
                loaded: true,
                client: action.result,
                errorLoadingClient: null,
                fetchOnMount: true
            };
        case 'MARK_AS_NOT_DUPLICATE_SUCCESS':
            return {
                ...state,
                duplicates: action.result
            };
        case 'ACTIVE_CLIENT_LOAD_FAIL':
            return {
                ...state,
                loaded: false,
                client: null,
                errorLoadingClient: action.error
            };
        case 'ACTIVE_CLIENT_EVENTS_LOAD_SUCCESS':
            var {result} = action;

            var events = [0,1].includes(result.paginationData.currentPage) ? result.events : state.events.concat(result.events);

            return {
                ...state,
                events,
                eventsPaginationData: result.paginationData
            };
        case 'ACTIVE_CLIENT_CONTACTS_LOAD_SUCCESS':
            return {
                ...state,
                contacts: action.result
            };
        case 'DELETE_NOTE_SUCCESS':
            var noteId = action.result.noteDeletedId;
            return {
                ...state,
                loaded: true,
                events: state.events.filter(e => ! (e.type == 'note' && e.id == noteId)),
                error: null
            };
        case 'CREATE_CONTACT_SUCCESS':
            return {
                ...state,
                contacts: state.contacts.concat([action.result])
            };
        case 'CREATE_SCHEDULE':
            return {
                ...state,
                isCreatingSchedule: true
            };
        case 'CREATE_SCHEDULE_SUCCESS':
            action.result.newlyAdded = true;
            var client = state.client;
            if (action.result.eventType == 'training'){
                client.bookedTraining = true;
            }
            if (action.result.eventType == 'demo'){
                client.bookedDemo = true;
            }
            return {
                ...state,
                events: state.events.concat([action.result]),
                client,
                isCreatingSchedule: false
            };
        case 'CREATE_NOTE_SUCCESS':
            action.result.newlyAdded = true;
            return {
                ...state,
                events: state.events.concat([action.result])
            };
        case 'DELETE_SCHEDULE_SUCCESS':
            var scheduleId = action.result.scheduleDeletedId;

            return {
                ...state,
                events: state.events.filter(e => e.id != scheduleId)
            };                
        case 'DETECT_DUPLICATES_SUCCESS':            
            return {
                ...state,
                duplicates: action.result
            };
        case 'UPDATE_CONTACT_SUCCESS':
            return {
                ...state,
                contacts: state.contacts.map(c => c.id == action.result.id ? action.result : c)
            };
        case 'UPDATE_USERS_ASSIGNED_TO_CLIENT_SUCCESS':
            var assignedUserIds = action.result;
            return {
                ...state,
                client: Object.assign(state.client, {assignedUserIds})
            };
        case 'UPDATE_CLIENT_TAGS':
            var { tags } = action;
            return {
                ...state,
                client: {...state.client, tags}
            };
        case 'CHANGE_MIDDYS_STATUS_SUCCESS':
            return {
                ...state,
                client: action.result
            };
        case 'MARK_AS_DUD_SUCCESS':
            return {
                ...state,
                client: action.result
            };
        case 'UNMARK_AS_DUD_SUCCESS':
            var client = state.client;

            return {
                ...state,
                client: {...client, isDud: false}
            };
        case 'QUALIFY_CLIENT_SUCCESS':
            var client = state.client;
            client.industryName = action.result.industryName;
            client.numberOfStaff = action.result.numberOfStaff;
            
            client.isQualified = 0;
            if (client.industryName && client.industryName != "Other"){
                client.isQualified += 0.5;
            }

            if (client.numberOfStaff && client.numberOfStaff != 1){
                client.isQualified += 0.5;
            }

            return {
                ...state,
                client
            };
        case 'FREE_PLAN_TYPE_CLIENT_SUCCESS':
            var client = state.client;
            return {
                ...state,
                client: {
                    ...client,
                    currentFreePlan: action.result.currentFreePlan,
                }
            };

        case 'SET_TRIAL_EXPIRY_SUCCESS':
            var client = state.client;
            return {
                ...state,
                client: {
                    ...client,
                    trialExpiresAt: action.result,
                    status: (client.status.includes('Expired') ? 'In Trial' : client.status),
                }
            };
        case 'CHANGE_TO_TRIAL_SUCCESS':
            var client = state.client;
            return {
                ...state,
                client: {
                    ...client,
                    trialExpiresAt: action.result.trialExpiresAt,
                    trialExpired: action.result.trialExpired,
                    companyOnTrial: action.result.companyOnTrial,
                    status: (action.result.companyOnTrial ? 'In Trial' : client.status),
                    currentPlan: action.result.currentPlan
                }
            };
        case 'UPDATE_SCHEDULE_SUCCESS':
            return {
                ...state,
                events: state.events.map(e => e.id == action.result.id ? action.result : e)
            };
        case 'LOAD_CREDIT_HISTORY_SUCCESS':
            return {
                ...state,
                creditHistory: action.result
            };
        case 'UPDATE_NOTE_SUCCESS':
            return {
                ...state,
                events: state.events.map(e => e.id == action.result.id ? action.result : e)
            };
        case 'RECORD_PHONE_CALL_COMPLETE_SUCCESS':
            console.log('recorded', action);
            return {
                ...state,
                events: state.events.map(e => e.id == action.result.id ? action.result : e)
            };
        case 'DELETE_CONTACT_SUCCESS':
            return {
                ...state,
                contacts: state.contacts.filter(c => c.id != action.result.deletedId)
            };
        case 'UPDATE_CLIENT_STAGE_SUCCESS':
            var client = action.result;

            return {
                ...state,
                client
            };
        case 'UPDATE_INTEREST_NOTES_SUCCESS':
            var client = {...state.client, interestNotes: action.result};

            return {
                ...state,
                client
            };
        case 'UPDATE_INTEREST_LEVEL':
            var { interestLevel } = action;
            var client = {...state.client, interestLevel};
            
            return {
                ...state,
                client
            };
        case 'RECORD_GO_LIVE_DATE_SUCCESS':
            var plannedGoLiveDate = action.result;
            var client = {...state.client, plannedGoLiveDate};
            
            return {
                ...state,
                client
            };
        case 'RECORD_GO_LIVE_DATE_FAIL':
            var client = {...state.client, plannedGoLiveDate: null};
            
            return {
                ...state,
                client
            };
        case 'MARK_QUALIFIED_AT_SUCCESS':
            console.log('MARK_QUALIFIED_AT_SUCCESS', action.result);
            var client = action.result;

            return {
                ...state,
                client
            };

        case 'MIGRATE_BILLING_REGION':
            var { billingRegion } = action;
            var client = {...state.client, billingRegion};

            return {
                ...state,
                client
            };

        case 'DISABLE_EMPLOYEE_SUCCESS':
            var client = {...state.client, users:action.result};

            return {
                ...state,
                client
            };
            
        case 'REENABLE_EMPLOYEE_SUCCESS':
            var client = {...state.client, users:action.result};

            return {
                ...state,
                client
            };

        case 'UPDATE_LOCK_STATUS_SUCCESS':
            var { newLockStatus } = action;
            var client = {...action.result, newLockStatus};

            return {
                ...state,
                client
            };
            
        case 'UPDATE_DISCOUNT_SUCCESS':
            var { newDiscount } = action;
            var client = {...action.result, newDiscount};

            return {
                ...state,
                client
            };

        case 'FLASH_DISABLE_LOADING_ON_MOUNT':
            return {
                ...state,
                fetchOnMount: false
            };
        default:
            return state;
    }
}

export function isLoadedForClientId(globalState, clientId) {
    return globalState.activeClient && globalState.activeClient.loaded && globalState.activeClient.client.id == clientId;
}

export function hasLoadedEventsForClientId(globalState, clientId) {
    return isLoadedForClientId(globalState, clientId) && globalState.activeClient.events;
}



// WEBPACK FOOTER //
// ./app/reducers/activeClient.js